/**
 * All the flags Identity subscribes to from Launch Darkly.
 *
 * Flags could be created in Launch Darkly as camelCase or kebab-case. Identity
 * is only supporting camelCase so make sure flags are using that convention
 * when created in Launch Darkly.
 */
export const subscribedFlags = {
  adminSideNav: false,
  paymentAdmin: false,
  paymentExternalBankAccount: false,
  paymentsPlatformFeeEnforcement: false,
  aiChat: false,
  txmResourceCenter: false,
  identityUpdateRoles: false,
  checklistV2: false,
  docTemplater: false,
  notRyan: false,
};

export type SubscribedFlags = typeof subscribedFlags;
export type SubscribedFlag = keyof SubscribedFlags;
